import React, {Fragment, useState} from 'react';
import {Collaboration, Popup} from 'components';
import {find, shorten, useNamedSelector} from 'helpers';
import {store} from 'store';
import css from './share.module.scss';

export function CollaborationMenu({ id, popup, collaborator, domain, context = domain, full }) {
  const [ pending, setPending ] = useState();
  const { relations, assigned } = useNamedSelector('relations.collaboration', { id, context }) || {};
  const current = find(relations, {email: collaborator.email});
  const share = props => {
    setPending(props.shareType);
    store.dispatch({ type: 'RELATIONS_SHARE', ...props });
    if (props.shareType == 'AssignerShare' || !full) {
      setTimeout(popup.close, 300);
    } else {
      setTimeout(popup.redirect(Collaboration.ShareMenu, { animate: collaborator }), 300);
    }
  }
  return (
    <div className={full ? css.menu : null}>
      <Popup.Menu>
        { full &&
          <Popup.Menu.SubHeading>
            { shorten(collaborator.name || collaborator.email, { chars: 30 }) }:
          </Popup.Menu.SubHeading>
        }
        <Popup.Menu.Checkbox pending={pending == 'Share'} checked={/Share/.test(current?.type)} onClick={() => share({ id, context, collaborator, shareType: 'Share' })}>
          Share
        </Popup.Menu.Checkbox>
        <Popup.Menu.Checkbox pending={pending == 'Collaborate'} checked={/Collaborate/.test(current?.type)} onClick={() => share({ id, context, collaborator, shareType: 'Collaborate' })}>
          Collaborate
        </Popup.Menu.Checkbox>
        { !assigned &&
          <Popup.Menu.Checkbox pending={pending == 'AssignerShare'} onClick={() => share({ id, context, collaborator, shareType: 'AssignerShare' })}>
            Assign <small className="secondary">(You will lose ownership)</small>
          </Popup.Menu.Checkbox>
        }
        { full &&
          <Fragment>
            <Popup.Menu.Separator />
            <Popup.Menu.Item icon="return" onClick={popup.redirect(Collaboration.ShareMenu, { animate: null })}>Back</Popup.Menu.Item>
          </Fragment>
        }
      </Popup.Menu>
    </div>
  );
}
